module.exports = __webpack_public_path__ + "img/price-storage.e5fee6f7.png";